export default __webpack_public_path__ + "static/media/postman.09dd36ab.jpg";